export const API_URL = process.env.REACT_APP_API || "http://localhost:9000";
export const CONF = process.env.REACT_APP_CONF || "otora";
export const SESSIONS =
  process.env.REACT_APP_SESSIONS || "A,B,C,D,E,F,G,H,I,J,K,L,X,1,2,3,4,5,6,7,8,9,10,11,12,13,14";
